import React from 'react';
import TableMui from './TableMui';
import moment from 'moment-timezone';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import getTableOptions from '../constants/TableOptions';
// import { dedCols } from '../constants/EmployeeCols';
import { dateFormat } from '../utils/formatter';
import ReactTable from '../components/ReactTable';
import { useDedCols } from '../hooks/EmployeeCols';

export default function Deductions(props) {
  const dedCols = useDedCols();

  if (!props.data && !props.isLoading) return null;

  const options = getTableOptions({ cols: dedCols, fileName: props.fileName });

  const tableData = (props.data || []).map((row) => {
    return [
      row.Ded,
      row.Description,
      row.Amount,
      row.Type,
      row.Balance,
      row.one,
      row.two,
      row.three,
      row.four,
      row.five,
      row.six,
      row.seven,
      row.eight,
      row.nine,
      dateFormat(new Date(row.BEGIN_DATE)),
      dateFormat(new Date(row.END_DATE)),
      row.Pty,
      row.Ar,
    ];
  });
  return (
    <ReactTable 
      cols={dedCols.map(item => {
        const upperAccessorKey = item.accessorKey.toUpperCase();
        return {
          ...item,
          accessorKey: upperAccessorKey,
          // Update accessorFn to use uppercase key if it exists
          ...(item.accessorFn && {
            accessorFn: (row) => new Date(row[upperAccessorKey])
          })
        };
      })} 
      data={props.data || []} 
      isLoading={props.isLoading} 
    />
    // <TableMui cols={dedCols} data={tableData} options={options} title="" />
  );
}
